import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Seo, { useLocalBusinessLd } from "@/components/Seo";
import { useI18n } from "@/i18n";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const { tc, t } = useI18n();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <Layout>
      <Seo title="Découvrir Rouen | Guide & conseils | NJ Conciergerie"
        description="Le guide de Rouen par NJ Conciergerie : nos conseils, bonnes adresses et incontournables pour profiter pleinement de votre séjour à Rouen."
        canonical="/decouvrir-rouen" jsonLd={useLocalBusinessLd()} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <span className="text-nj-gold text-xs tracking-[0.28em] uppercase font-semibold">{t("nav.blog")}</span>
        <h1 className="font-serif font-light text-4xl sm:text-5xl text-nj-text mt-3">Le guide de Rouen</h1>
        <p className="text-nj-text2 mt-3 max-w-xl">Nos conseils, adresses et incontournables pour profiter pleinement de votre séjour à Rouen.</p>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 mt-12" data-testid="blog-list">
          {posts.map((p) => (
            <Link key={p.id} to={`/decouvrir-rouen/${p.slug}`} className="nj-card group" data-testid={`blog-${p.slug}`}>
              <div className="overflow-hidden rounded-md aspect-[3/2] bg-nj-olive">
                <img src={p.cover} alt={tc(p.title)} loading="lazy" className="nj-card-img w-full h-full object-cover" />
              </div>
              <h3 className="font-serif text-xl text-nj-text mt-4 group-hover:text-nj-primary transition-colors">{tc(p.title)}</h3>
              <p className="text-sm text-nj-text2 mt-2 leading-relaxed">{tc(p.excerpt)}</p>
              <span className="inline-flex items-center gap-1.5 text-nj-primary text-sm font-medium mt-3 group-hover:gap-2.5 transition-all">Lire l'article <ArrowRight className="w-4 h-4" /></span>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
